var map = {
	"./list_en.svg": "90pl",
	"./list_fr.svg": "erYr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cgM4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers ^\.\/list_.*\.svg$
// module id = cgM4
// module chunks = 0